import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import "./AddDues.css";
import { FaStarOfLife } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi"; // Close & Upload icons
import axios from "axios";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { MdEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import MessageBox from "../MessageBox/MessageBox";

export default function AddDues() {
  const permissions = useSelector((state) => state.permissions);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const location = useLocation();
  //message box
  const staffName = useSelector((state) => state.staffname);
  const Id = useSelector((state) => state.id);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [dueDBid, setDueDBid] = useState(null);

  //edit
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditable, setIsEditable] = useState(true); // default true so fields are editable before submit

  //fetch data from customer page state
  const [customerid, setCustomerId] = useState("");
  const [customerData, setCustomerData] = useState(null);
  const [error, setError] = useState();

  //staff
  const [staffData, setstaffData] = useState([]);
  
  //write state to get dues schema
  const [duesData, setDuesData] = useState({
    duesId: "",
    dueOpenLastDay: "",
    customerid: "",
    customername: "",
    contactnum: "",
    alternatenum: "",
    invoiceDate: "",
    followupPerson: "",
    totalBillAmount: "",
    dueAmount: "",
    expectedPaymentDate: "",
    dueStatus: "Open",
    dueLeadstatus: {
      dueNotes: "",
      dueImage: "",
      dueExpectedPaymentDate: "",
    },
  });

  //merge the customer data and the due

  const handleDuesChange = (e) => {
    const { name, value } = e.target;

    if (name in duesData.dueLeadstatus) {
      setDuesData((prevState) => ({
        ...prevState,
        dueLeadstatus: {
          ...prevState.dueLeadstatus,
          [name]: value,
        },
      }));
    } else {
      setDuesData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  //open status
  const [isOpenConverted, setIsOpenConverted] = useState(false);
  //post data
const handleDuesSubmit = async (e) => {
  e.preventDefault();

  // Step 1: Confirm submission
  const result = await Swal.fire({
    title: "Do you want to submit the Due Details?",
    showCancelButton: true,
    confirmButtonText: "Submit",
  });

  if (!result.isConfirmed) return;

  const now = new Date();
  const date = now.toLocaleDateString();
  const time = now.toLocaleTimeString();

  const dataToSubmit = {
    ...duesData,
    customerid: customerid || duesData.customerid,
    customername: customerData?.installcustomerName || duesData.customername || "",
    contactnum: customerData?.installcontactNum || duesData.contactnum || "",
    alternatenum: customerData?.installalternateNum || duesData.alternatenum || "",
    dueLeadstatus: {
      dueExpectedPaymentDate:
        duesData.dueLeadstatus?.dueExpectedPaymentDate || "",
      dueNotes: duesData.dueLeadstatus?.dueNotes || "",
      dueImage: duesData.dueLeadstatus?.dueImage || "",
    },
    createdBy: {
      staffName: staffName,
      _id: Id,
      date,
      time,
    },
  };

  let savedId = "";

  try {
    // Step 2: Submit dues data
    const duesResponse = await axios.post(apiUrl + "add-dues", dataToSubmit);
    savedId = duesResponse.data.data?._id;
    setDueDBid(savedId);

    // Step 3: Add message with file if available
    const formData = new FormData();
    formData.append("pageRefId", savedId);
    formData.append("page", "Dues");
    formData.append("colorCode", "#fbdc6e");
    formData.append("description", duesData.dueLeadstatus?.dueNotes || "No Description");
    formData.append("staffPic", "");

    if (selectedFile) {
      formData.append("image", selectedFile);
    }

    formData.append("updatesHistory[staff][name]", staffName);
    formData.append("updatesHistory[staff][id]", Id);
    formData.append("updatesHistory[status]", duesData.dueStatus || "Open");

    await axios.post(apiUrl + "add-message", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // Step 4: Try to fetch messages, but continue even if none found
    try {
      const messagesRes = await axios.get(`${apiUrl}messages/${savedId}`);
      setMessageData(messagesRes.data.data || []); // Ensure empty array if no data
    } catch (msgError) {
      console.log("No messages found for this task");
      setMessageData([]); // Set empty array if error occurs
    }

    Swal.fire("Success!", "Dues Details Submitted", "success");
    setIsSubmitted(true);
    setIsEditable(false);
    setShowMessageBox(true); // Still show message box even if empty
  } catch (error) {
    console.error("Error while submitting Dues data", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.response?.data?.message || "Something went wrong!",
    });

    // Still try to show message box even if there's an error
    setShowMessageBox(true);
    setMessageData([]); // Initialize with empty array
  }
};

  console.log(dueDBid);
  const handleEdit = () => {
    setIsEditing(true);
    setIsEditable(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setIsEditable(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(apiUrl + "update-dues", {
        id: dueDBid,
        ...duesData,
      });

      if (response.data?.data) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Dues updated successfully.",
        });
        setIsEditing(false);
        setIsEditable(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Dues not found.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  //fetching data for edit
  useEffect(() => {
    if (location.state?.id) {
      axios
        .post(apiUrl + "view-dues", {
          id: location.state.id,
        })
        .then((res) => {
          setDuesData(res.data.message);
        })
        .catch((err) => console.error("Fetch failed", err));
    }
  }, [location.state?.id, apiUrl]);
  //automatically generating due id
  useEffect(() => {
    fetch(apiUrl + "generate-duesid-dues")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Lead ID:", data.duesId); // Debugging log

        setDuesData((prev) => ({
          ...prev, // Spread previous state
          duesId: data.duesId, // Update only the duesId field
          createdDate: new Date().toISOString().split("T")[0], // Set today's date
        }));
      })

      .catch((error) => console.error("Error fetching Lead ID:", error));
  }, [apiUrl]);
  //fetching customer id
  useEffect(() => {
    const fetchCustomerDataByNumericId = () => {
      if (!customerid.trim()) {
        setCustomerData(null);
        setError("");
        return;
      }
      axios
        .get(apiUrl + `get-customer-by-numeric-id/${customerid}`)
        .then((response) => {
          if (response.data.success) {
            setCustomerData(response.data.data); // Set the customer data from 'data' property
            setError("");
          } else {
            setError("Customer not found");
            setCustomerData(null);
          }
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            setError("Customer not found");
          } else {
            setError("An error occurred.");
          }
          setCustomerData(null);
        });
    };

    fetchCustomerDataByNumericId();
  }, [customerid, apiUrl]);

  //fetching staff details

  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setstaffData(res.data.message);
      });
  }, [apiUrl]);

  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form>
          <Row>
            <Col>
              <h3>Dues</h3>
            </Col>

            <Col className="text-end me-5">
              {!isSubmitted ? (
                <button
                  className="blue-btn my-1"
                  type="submit"
                  onClick={handleDuesSubmit}
                >
                  Submit
                </button>
              ) : isEditing ? (
                <>
                  <button
                    className="blue-btn my-1"
                    type="button"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="black-btn my-1"
                    type="button"
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  {permissions?.Due?.["Due Updates"]?.Write && (
                    <button
                      className="black-btn mx-1 my-1"
                      type="button"
                      onClick={handleEdit}
                    >
                      <span>
                        <MdEdit className="mx-1 editicon-recovery" />
                      </span>
                      Edit
                    </button>
                  )}
                </>
              )}
            </Col>
          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Dues Details</h6>
          </div>

          <div className="border-container ">
            <Row className="text-start lead-id-row  mb-4 mt-4 ms-4 ">
              <p className="ps-5 paragraph-lead-id">
                Due ID -{" "}
                <span className="text-primary ">{duesData.duesId}</span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <Row>
                  <Col md={6} sm={12}>
                    {" "}
                    <lable>Customer Id</lable>
                    <br />
                    <input
                      type="text"
                      style={{ textTransform: "capitalize " }}
                      className="form-input "
                      placeholder="Enter custmer ID"
                      name="customerid"
                      value={customerid}
                      onChange={(e) => {
                        setCustomerId(e.target.value); // Update the state
                        handleDuesChange(e);
                      }}
                      disabled={!isEditable}
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Col>
                  <Col md={6} sm={12}>
                    {" "}
                    <lable>Customer Name</lable>
                    <br />
                    <input
                      type="text"
                      style={{ textTransform: "capitalize " }}
                      className="form-input "
                      placeholder="Enter customer name"
                      name="customername"
                      value={customerData?.installcustomerName || ""}
                      onChange={handleDuesChange}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter contact number"
                      className="form-input"
                      name="contactnum"
                      maxLength={10}
                      value={customerData?.installcontactNum || ""}
                      required
                     disabled
                      onChange={handleDuesChange}
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      name="alternatenum"
                      value={customerData?.installalternateNum || ""}
                      maxLength={10}
                      className="form-input"
                      placeholder="Enter contact number"
                      onChange={handleDuesChange}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Invoice Date</lable>
                    <br />
                    <input
                      type="date"
                      // placeholder="Enter phone number"
                      className="form-input"
                      name="invoiceDate"
                      value={duesData?.invoiceDate || ""}
                      maxLength={10}
                      required
                      onChange={handleDuesChange}
                      disabled={!isEditable}
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <label>Follow up Person</label>
                    <br />
                    <select
                      className="dropbtn form-input-select"
                      name="followupPerson"
                      value={duesData?.followupPerson || ""}
                      onChange={handleDuesChange}
                      disabled={!isEditable}
                      style={{
                        padding: "10px",
                        width: "85%",
                        // border: "2px solid #a7a7a7",
                        borderRadius: "4px",
                        // backgroundColor: "#fff",
                        marginTop: "10px",
                      }}
                    >
                      <option value="">Select staff</option>
                      {staffData.length > 0 ? (
                        staffData.map((staff) => (
                          <option key={staff._id} value={staff.staffName}>
                            {staff.staffName}
                          </option>
                        ))
                      ) : (
                        <option disabled>Loading staff...</option>
                      )}
                    </select>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Total Bill Amount</lable>
                    <br />
                    <input
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter total bill amount"
                      name="totalBillAmount"
                      value={duesData?.totalBillAmount || ""}
                      onChange={handleDuesChange}
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Due Amount</lable>
                    <br />

                    <input
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter due amount"
                      name="dueAmount"
                      value={duesData?.dueAmount || ""}
                      onChange={handleDuesChange}
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start"></Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Expected Payment Date</lable>
                    <br />
                    <input
                      className="field form-input"
                      type="date"
                      name="expectedPaymentDate"
                      value={duesData?.dueLeadstatus?.dueExpectedPaymentDate}
                      onChange={handleDuesChange}
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <Row className="ms-2">
                      <label>Due Status</label>
                      <br />
                      <input
                        type="button"
                        className="form-input converted-form"
                        name="dueStatus"
                        value={duesData?.dueLeadstatus?.dueStatus || "Open"}
                        onClick={() => setIsOpenConverted(true)}
                        disabled={!isEditable}
                        style={{
                          textTransform: "capitalize",
                          backgroundColor: "#fbdc6e",
                          color: "rgb(94, 94, 14)",
                        }}
                      />

                      {isOpenConverted && (
                        <div className="overlay1-converted">
                          <div className="modal1-converted">
                            <Container>
                              <button
                                className="close-btn1"
                                onClick={() => setIsOpenConverted(false)}
                              >
                                <span style={{ fontSize: "20px" }}>
                                  &times;
                                </span>
                              </button>

                              <div className="open-button border">
                                <h5 style={{ textTransform: "capitalize" }}>
                                  {duesData?.dueLeadstatus?.dueStatus || "Open"}
                                </h5>
                              </div>

                              <textarea
                                className="converted-textbox"
                                placeholder="Enter Notes"
                                name="dueNotes"
                                value={duesData?.dueLeadstatus?.dueNotes || ""}
                                onChange={handleDuesChange}
                                style={{
                                  textTransform: "capitalize",
                                  resize: "none",
                                }}
                              />

                              <div className="upload-section">
                                <label className="upload-btn">
                                  <FiUpload className="upload-icon" />
                                  Upload Image
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    hidden
                                  />
                                </label>
                                {selectedFile && (
                                  <p className="file-name">
                                    {selectedFile.name}
                                  </p>
                                )}
                              </div>

                              <Row>
                                <Col className="date-update-textbox">
                                  <label>Expected Payment Date</label>
                                  <br />
                                  <input
                                    type="date"
                                    className="field form-input"
                                    name="dueExpectedPaymentDate"
                                    value={
                                      duesData?.dueLeadstatus
                                        ?.dueExpectedPaymentDate || ""
                                    }
                                    onChange={handleDuesChange}
                                    min={new Date().toISOString().split("T")[0]}
                                  />
                                </Col>
                                <Col className="uploadbtn-install">
                                  <button
                                    type="button"
                                    className="blue-btn"
                                    onClick={() => setIsOpenConverted(false)}
                                  >
                                    Upload
                                  </button>
                                </Col>
                              </Row>
                            </Container>
                          </div>
                        </div>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>

        {showMessageBox && (
          <Row className="container ms-3  me-5">
            <Col md={6} sm={12}>
              <div>
                {messageData &&
                  messageData.map((msg) => (
                    <MessageBox key={msg._id} message={msg} />
                  ))}{" "}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              {/* Updates History Section */}
              <div className="compact-updates-history">
                <div className="compact-updates-header"> Updates History </div>
                {messageData &&
                  messageData.map((data, index) => (
                    <div className="compact-update text-center" key={index}>
                      <div className="compact-update-date text-center">
                        {new Date(data.updatesHistory.date).toLocaleDateString(
                          "en-GB"
                        ) +
                          " - " +
                          new Date(data.updatesHistory.date)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(":", ".")}
                      </div>

                      <div className="compact-update-user text-center">
                        {" "}
                        {data.updatesHistory.staff?.name}{" "}
                      </div>
                      <div
                        className={"compact-update-status text-center "}
                        style={{
                          color: data.colorCode ? data.colorCode : "#000000",
                        }}
                      >
                        {data.updatesHistory.status}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}
